import React from 'react';
import './Contact.css';

function Contact() {
  // Event-Handler für die Buttons
  const handleCall = () => {
    window.location.href = 'tel:+4915142897967';
  };

  const handleEmail = () => {
    window.location.href = 'mailto:info@service.prosperly.de';
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/4915142897967', '_blank');
  };

  const handleBooking = () => {
    window.open('https://outlook.office365.com/book/prosperlyService@prosperly.de/', '_blank');
  };

  return (
    <div className="contact-container">
      <h1>Kontaktiere uns</h1>
      <p>Komm in Kontakt mit deinem digitalen Hausverwalter</p>

      <div className="contact-grid">
        <div className="contact-card">
          <h3>📞 Phone</h3>
          <p>Direkte Telefonnummer zum Hausverwalter</p>
          <p>+49 151 4289 7967</p>
          <button onClick={handleCall}>Ruf jetzt an!</button>
        </div>
        <div className="contact-card">
          <h3>📧 Email</h3>
          <p>Schick uns eine E-Mail an:</p>
          <p>info@service.prosperly.de</p>
          <button onClick={handleEmail}>Sende email</button>
        </div>
        <div className="contact-card">
          <h3>💬 WhatsApp</h3>
          <p>Schreib uns gerne auf WhatsApp</p>
          <p>+49 151 4289 7967</p>
          <button onClick={handleWhatsApp}>Öffne WhatsApp</button>
        </div>
        <div className="contact-card">
          <h3>📅 Buch dein Meeting</h3>
          <p>Buch dir einen Zeitslot, der dir passt</p>
          <p>Verfügbar von Mo–Fr, 9:00–17:00</p>
          <button onClick={handleBooking}>Buch jetzt</button>
        </div>
      </div>

      <div className="office-hours">
        <h3>Öffnungszeiten</h3>
        <p>Montag – Freitag: 9:00 – 17:00</p>
        <p>Samstag: 10:00 – 14:00</p>
        <p>Sonntag: 10:00 - 14:00</p>
      </div>
    </div>
  );
}

export default Contact;
